import { useMutation } from "react-query";
import Axios from "axios";
import { NoPlaceZoneBooking } from "../../../features/Booking-Form/typings/booking-service-administration.types";
import { BookingScheduleDto } from "../../../features/Booking-Form/typings/booking.types";

export function useRemoteFetchNoPlaceZoneBookingScheduleMutation() {
  return useMutation({
    mutationFn: async (bookingScheduleDto: BookingScheduleDto): Promise<NoPlaceZoneBooking[]> => {
      const { userIds, startDate, endDate } = bookingScheduleDto;
      const { data } = await Axios.get<NoPlaceZoneBooking[]>("/booking-schedule/noplacezone", {
        params: { userIds, startDate, endDate }
      });
      return data;
    }
  });
}
